import axios from 'axios'
import store from '@/store'
import { CRM_API_URL } from '@/constants/api'

function fetchOrdersStatistics (data) {
  const source = axios.CancelToken.source()
  const url = `${CRM_API_URL}/statistic/call-center/orders`
  store.dispatch('requests/addUniqueRequest', { url, source })

  return axios
    .post(url, data, { cancelToken: source.token })
    .then((response) => response.data)
}

function fetchOrdersTimeLoadStatistics (data) {
  const source = axios.CancelToken.source()
  const url = `${CRM_API_URL}/statistic/call-center/orders/time-load`
  store.dispatch('requests/addUniqueRequest', { url, source })

  return axios.post(url, data, { cancelToken: source.token })
    .then(response => response.data)
}

function fetchProportionByOrderStatuses (data) {
  const source = axios.CancelToken.source()
  const url = `${CRM_API_URL}/statistic/call-center/orders/statuses/proportion`
  store.dispatch('requests/addUniqueRequest', { url, source })

  return axios.post(url, data, { cancelToken: source.token })
    .then(response => response.data)
}

function fetchProportionByOrderSVP (data) {
  const source = axios.CancelToken.source()
  const url = `${CRM_API_URL}/statistic/call-center/orders/svp/proportion`
  store.dispatch('requests/addUniqueRequest', { url, source })

  return axios
    .post(url, data, { cancelToken: source.token })
    .then((response) => response.data)
}

function fetchProportionByOrderSources (data) {
  const source = axios.CancelToken.source()
  const url = `${CRM_API_URL}/statistic/call-center/orders/sources/proportion`
  store.dispatch('requests/addUniqueRequest', { url, source })

  return axios
    .post(url, data, { cancelToken: source.token })
    .then((response) => response.data)
}

export default {
  fetchOrdersStatistics,
  fetchOrdersTimeLoadStatistics,
  fetchProportionByOrderStatuses,
  fetchProportionByOrderSVP,
  fetchProportionByOrderSources,
}
